<template>
  <div class="relative">
    <div
      class="rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold cursor-pointer"
      :style="{backgroundColor: badge_border, color: text_color}"
    >
      {{ initial }}
    </div>
    <span
      v-if="unreadMessageCount > 0"
      class="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white"
    />
  </div>
</template>

<script>

import {generateSimilarColor} from '@/utils/common'
import {mapGetters} from 'vuex'

export default {
  computed:{
    ...mapGetters('auth',['current_user', 'unreadMessageCount']),
    initial() {
      if (this.current_user?.first_name && this?.current_user.last_name) {
        return this.current_user.first_name.charAt(0) + this.current_user.last_name.charAt(0)
      }
      return ''
    },
    badge_border() {
      const color = generateSimilarColor(this.current_user.color,0.0,-50.0)
      return color
    },
    text_color() {
      const color = '#FFFFFF'
      return color
    }
  },
}
</script>

<style>
.hidden {
  display: none;
}
</style>
